import React from 'react';


import {
    Button,
    Flash,
    Form,
    FormSection,
    FormField,
    Input,
    ColumnLayout,
    Table,
    TablePagination,
    Modal,
    Spinner

} from 'AWS-UI-Components-React';

import {
    JSClient,
    Header
} from './common';

export const COLUMN_DEFINITIONS = [{
    id: 'beerId',
    header: () => 'Beer Name',
    cell: (item) => item.name,
    minWidth: '100px',
    allowLineWrap: false
}];

export class BeerTable extends React.Component {

    constructor(props) {
        super(props)
        this.state = { unknownloaderror: false, initialLoadDone: false, user: "", beerLoadDone: false, beers: [], addBeerOpen: false };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.showAddModal = this.showAddModal.bind(this);
        this.hideAddModal = this.hideAddModal.bind(this);
        this.saveBeer = this.saveBeer.bind(this);
        this.getBeersResultHandler = this.getBeersResultHandler.bind(this);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({ user: identityResult.username, initialLoadDone: true });
        });
        this.client.getBeers(this.getBeersResultHandler);
    }

    componentWillMount() {
        this.client = new JSClient({ onReady: this.clientLoaded });
    }

    getBeersResultHandler(beerResult) {
        this.setState({ beers: beerResult.beers, beerLoadDone: true });
    }

    headerCounter(items) {
        return items.length;
    }

    showAddModal() {
        this.setState({ addBeerOpen: true });
    }

    hideAddModal() {
        this.setState({ addBeerOpen: false });
    }

    saveBeer() {
        this.hideAddModal();
        const s = this;
        this.client.postBeer(function (response) {
            s.client.getBeers(s.getBeersResultHandler);
        }, null, document.getElementById('beerNameInput').value, null);
    }


    render() {
        if (!this.state.initialLoadDone) {
            return (<div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'> <Spinner />  </div>)
        }
        return (
            <div>
                <Modal visible={this.state.addBeerOpen} header="Add a beer" footer={<span className="awsui-util-f-r"> <Button variant="link" text="Cancel" onClick={this.hideAddModal}></Button> <Button variant="primary" text="Save" onClick={this.saveBeer}></Button> </span>} > <span> <h5> Give the beer a name. </h5> <Input type="text" controlId="beerNameInput" lable="Beer name" /> </span> </Modal>
                <div >
                    <div className='offset-xxs-1 col-s-8 offset-l-2 col-xl-3'>
                        <h2>Hello {this.state.user}!</h2>

                        <Table
                            columnDefinitions={COLUMN_DEFINITIONS}
                            loading={!this.state.beerLoadDone}
                            header={(
                                <Header
                                    title="Beers"
                                    counter={this.headerCounter(this.state.beers)}
                                />
                            )}
                            items={this.state.beers}
                            empty={<div className="awsui-util-t-c">
                                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                                    <b>{"No beers found - boo!"}</b>
                                </div>
                            </div>}
                        >

                            <TablePagination />

                        </Table>

                    </div>
                </div>
            </div>


        );
    }
}


// WEBPACK FOOTER //
// ./src/components/beer_table.jsx